<div class="user-panel" [class.is-online]="online">
  <!-- Dot online absoluto sobre el avatar — visible cuando `online === true`.
       Animacion sutil de pulse para feedback. -->
  <span class="user-online-dot" *ngIf="online && menuMode === 'context'" aria-hidden="true"></span>
  <dx-drop-down-button
    *ngIf="menuMode === 'context'"
    stylingMode="text"
    dropDownContentTemplate="dropDownTemplate"
    [icon]="user?.avatarUrl || 'user'"
    [text]="user?.name || user?.email || 'Cuenta'"
    [showArrowIcon]="true"
    [elementAttr]="{
      class: 'user-button'
    }"
    [dropDownOptions]="{
      width: 'auto'
    }"
    (onContentReady)="handleDropDownButtonContentReady($event)"
  >
    <div *dxTemplate="let data of 'dropDownTemplate'">
      <user-menu-section
        [menuItems]="menuItems"
        [showAvatar]="false"
        [user]="user"
      ></user-menu-section>
    </div>
  </dx-drop-down-button>
  <div *ngIf="menuMode === 'list'">
    <user-menu-section
      [menuItems]="menuItems"
      [showAvatar]="true"
      [user]="user"
    ></user-menu-section>
  </div>
</div>
